import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import classNames from 'classnames'
import { useHistory, useRouteMatch } from 'react-router-dom'

import { getView } from '../../../../ducks/views'
import { buildIndex } from '../../../../utils/indexing'
import Checkbox from '../../../Shared/Forms/Checkbox'
import Button from '../../../Shared/Button'
import { IconButton } from '../../../Shared/Icon'
import { TrialBannerContext } from '../../../Shared/Page'
import ActionMenu, { showActionModal } from '../ActionMenu'

import styles from './SelectionHeader.module.css'

const Actions = function SelectionHeaderActions({
  actions: actionOptions,
  selection,
  viewId,
}) {
  const history = useHistory()
  const view = useSelector(getView(viewId))
  const recordIds = selection

  const actions = actionOptions[0].children
  const action1 = actions[0]
  const action2 = actions[1]

  const baseURL = `/databases/views/${viewId}`

  const handleClickAction = option => () => {
    showActionModal(option.value, { history, recordIds, baseURL })
  }

  return (
    <>
      {action1 && <p className={styles.label}>Bulk Actions:</p>}
      {action1 && (
        <Button onClick={handleClickAction(action1)}>{action1.label}</Button>
      )}
      {action2 && (
        <Button color="grey" onClick={handleClickAction(action2)}>
          {action2.label}
        </Button>
      )}
      <ActionMenu
        recordIds={selection}
        view={view}
        actions={actionOptions}
        baseURL={baseURL}
      />
    </>
  )
}

export default function SelectionHeader({
  items,
  selection,
  setSelection,
  actions,
}) {
  const match = useRouteMatch()
  const { viewId } = match.params

  useEffect(() => {
    const itemsMap = buildIndex(items, itm => itm.__pk)
    const newSelection = []

    for (let id of selection) {
      if (itemsMap[id]) {
        newSelection.push(id)
      }
    }

    if (newSelection.length !== selection.length) {
      setSelection(newSelection)
    }
  }, [setSelection, selection, items])

  const handleClick = () => {
    let newSelection = []

    if (selection.length < items.length) {
      newSelection = items.map(itm => itm.__pk)
    }

    setSelection(newSelection)
  }

  const checked =
    selection.length > 0
      ? selection.length === items.length
        ? true
        : 'some'
      : false

  return (
    <TrialBannerContext.Consumer>
      {bannerVisible => (
        <div
          className={classNames(
            styles.wrapper,
            bannerVisible && styles.bannerVisible
          )}
        >
          <Checkbox small value={checked} onChange={handleClick} />
          <p className={classNames(styles.countLabel, styles.label)}>
            {selection.length > 0
              ? `${selection.length} item${
                  selection.length === 1 ? '' : 's'
                } selected`
              : `Showing ${items.length} item${items.length === 1 ? '' : 's'}`}
          </p>
          {selection.length > 0 ? (
            <div className={styles.actions}>
              <Actions
                actions={actions}
                selection={selection}
                viewId={viewId}
              />
            </div>
          ) : (
            <IconButton
              to={`/databases/edit-view/${viewId}`}
              icon="settings"
              color="grey"
            />
          )}
        </div>
      )}
    </TrialBannerContext.Consumer>
  )
}
